import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cue-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ModalFooterComponent {}
